"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProjectsList = exports.mapDispatchToProps = void 0;
exports.getRolesString = getRolesString;
exports.compareRoles = compareRoles;
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var memoize = require("fast-memoize");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var recompose_1 = require("recompose");
var userProjectActions = require("@caddigital/sok-reducers/lib/actions/user/projects");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var userGroups_1 = require("utils/userGroups");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var TableRowIcon_1 = require("components/TableRowIcon");
var ColumnFilter_1 = require("components/ColumnFilter");
var text_1 = require("utils/text");
var Types = require("types");
var SortButton = sok_ui_1.Table.SortButton;
var headers = ['name', 'id', 'roles', 'company', 'description'];
function getValue(key, item) {
    switch (key) {
        case 'id':
            return item.project.id.toString();
        case 'name':
            return item.project.name;
        case 'company':
            return item.project.customerName || '';
        case 'roles':
            return getRolesString(item.groups);
        case 'description':
            return item.project.description || '';
    }
    return '';
}
var mapStateToProps = function (state) {
    return {
        projects: state.user.projects,
        user: state.user.projects.user,
        orderByOptions: state.user.projects.orderByOptions,
        filterOptions: state.user.projects.filterOptions,
        searchString: state.user.projects.searchString
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (user) {
        return dispatch(userProjectActions.fetchProjectsRequests(user));
    },
    sortBy: function (orderBy, order) {
        return dispatch(userProjectActions.setOrderByOptions(orderBy, order));
    },
    setColumnFilter: function (filter, value) {
        return dispatch(userProjectActions.setFilterOptions(filter, value));
    },
    toggleSelect: function (ids) {
        dispatch(userProjectActions.toggleSelect(ids));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhanceHeader = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    return (0, List_1.shallowDiffers)(nextProps.style, props.style) ||
        nextProps.orderByOptions !== props.orderByOptions ||
        nextProps.filterOptions !== props.filterOptions ||
        nextProps.projects.selectedProjects !== props.projects.selectedProjects;
}));
function getRolesString(groups) {
    var noCat = groups.reduce(function (acc, item) {
        if (item.categoryName === undefined) {
            acc.push((0, userGroups_1.getLocalizedUserGroupName)(item.name));
        }
        return acc;
    }, []);
    var hasCat = Object.entries(groups.reduce(function (acc, item) {
        if (item.categoryName !== undefined) {
            acc[item.categoryName] = acc[item.categoryName] || [];
            acc[item.categoryName].push(item);
        }
        return acc;
    }, {}))
        .map(function (_a) {
        var cat = _a[0], groups = _a[1];
        return "".concat((0, userGroups_1.getLocalizedUserGroupName)(cat), " / ").concat(groups
            .sort(function (a, b) { return a.name.localeCompare(b.name); })
            .map(function (x) { return (0, userGroups_1.getLocalizedUserGroupName)(x.name); })
            .join(' + '));
    })
        .sort(function (a, b) { return a.localeCompare(b); });
    return noCat.concat(hasCat).join(', ');
}
function compareRoles(a, b) {
    var first = getRolesString(a.groups);
    var second = getRolesString(b.groups);
    return first.localeCompare(second);
}
function getFilteredData(list, seachString, filters) {
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        if (seachString.length > 0) {
            return list.filter(function (item) {
                return item.project.id.toString().includes(seachString);
            });
        }
        return __spreadArray([], list, true);
    }
    var filtered = list.reduce(function (result, item) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var searchValue = filters[key];
            var value = getValue(key, item);
            if (value.toString().toLowerCase().indexOf(searchValue.toLowerCase()) === -1) {
                return result;
            }
        }
        if (item.project.id.toString().includes(seachString)) {
            result.push(item);
        }
        return result;
    }, []);
    return filtered;
}
var Header = enhanceHeader(function (_a) {
    var style = _a.style, className = _a.className, orderByOptions = _a.orderByOptions, sortBy = _a.sortBy, setColumnFilter = _a.setColumnFilter, filterOptions = _a.filterOptions, projects = _a.projects, toggleSelect = _a.toggleSelect;
    return (React.createElement("div", { className: className + ' row', style: style },
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(TableRowIcon_1.TableRowIcon, { icon: 'fa-check', className: projects.allSelected ? 'selected' : '', circle: true, onClick: function (e) {
                    e.stopPropagation();
                    if (projects.allSelected) {
                        toggleSelect([]);
                    }
                    else {
                        toggleSelect(projects.list.map(function (p) { return p.project.id; }));
                    }
                } })),
        headers.map(function (header) {
            var dataKey = '__' + header.replace(/-/g, '');
            var order = orderByOptions.orderBy === header && orderByOptions.order === 'asc'
                ? 'desc'
                : 'asc';
            return (React.createElement("div", { className: 'row__column name ' + dataKey, key: "header-".concat(dataKey) },
                React.createElement("div", null, (0, translation_1.getLocalization)("components/userProjects/header/".concat(header))),
                React.createElement(SortButton, { className: " sort d-none d-desktop-table-cell", disabled: false, onChange: function () { return sortBy(header, order); }, order: orderByOptions.orderBy === header
                        ? orderByOptions.order
                        : undefined }),
                React.createElement(ColumnFilter_1.ColumnFilter, { className: classNames('filter', filterOptions && filterOptions[header] ? 'active' : ''), columnIdentifier: header, textInputValue: filterOptions && filterOptions[header]
                        ? filterOptions[header] || ''
                        : '', inputType: 'text', setColumnFilterString: function (field, value) {
                        return setColumnFilter(field, value);
                    }, clearColumnFilter: function (field) { return setColumnFilter(field, undefined); } })));
        })));
});
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var items = data.items, toggleSelect = data.toggleSelect, selectedProjects = data.selectedProjects;
    var row = items[index];
    var elements = [
        React.createElement("div", { className: "row__column narrow", key: 'select-project' },
            React.createElement(TableRowIcon_1.TableRowIcon, { icon: 'fa-check', className: selectedProjects &&
                    selectedProjects.find(function (id) { return id === row.project.id; })
                    ? 'selected'
                    : '', circle: true, onClick: function (e) {
                    e.stopPropagation();
                    toggleSelect([row.project.id]);
                } }))
    ];
    for (var i = 0; i < headers.length || 0; i++) {
        var key = headers[i];
        var dataKey = '__' + headers[i].replace(/-/g, '');
        var value = getValue(key, row);
        elements.push(React.createElement("div", { key: headers[i], className: 'row__column ' + dataKey },
            React.createElement("span", null, value)));
    }
    return (React.createElement("div", { className: className, style: style, key: "row-element-".concat(row.project.id) }, elements));
}, function (nextProps, props) { return !(0, List_1.shallowDiffers)(nextProps, props); });
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var orderBy = this.props.orderByOptions.orderBy;
        var order = this.props.orderByOptions.order === 'asc' ? 1 : -1;
        var list = getFilteredData(this.props.projects.list, this.props.searchString, this.props.filterOptions).sort(function (a, b) {
            switch (orderBy) {
                case 'name':
                    return a.project[orderBy].localeCompare(b.project[orderBy]) * order;
                case 'company':
                    return ((a.project.customerName || '').localeCompare(b.project.customerName || '') * order);
                case 'roles':
                    return compareRoles(a, b) * order;
                case 'description':
                    return ((a.project.description || '').localeCompare(b.project.description || '') * order);
                case 'id':
                    return (a.project[orderBy] - b.project[orderBy]) * order;
                default:
                    return 0;
            }
        });
        this.props.setItems(list);
    },
    componentDidUpdate: function (prevProps) {
        var list = this.props.items;
        if (this.props.searchString !== prevProps.searchString ||
            this.props.orderByOptions !== prevProps.orderByOptions ||
            this.props.filterOptions !== prevProps.filterOptions ||
            this.props.projects.list !== prevProps.projects.list) {
            var orderBy_1 = this.props.orderByOptions.orderBy;
            var order_1 = this.props.orderByOptions.order === 'asc' ? 1 : -1;
            list = getFilteredData(this.props.projects.list, this.props.searchString, this.props.filterOptions).sort(function (a, b) {
                switch (orderBy_1) {
                    case 'name':
                        return (a.project[orderBy_1].localeCompare(b.project[orderBy_1]) * order_1);
                    case 'company':
                        return ((a.project.customerName || '').localeCompare(b.project.customerName || '') * order_1);
                    case 'roles':
                        return compareRoles(a, b) * order_1;
                    case 'description':
                        return ((a.project.description || '').localeCompare(b.project.description || '') * order_1);
                    case 'id':
                        return (a.project[orderBy_1] - b.project[orderBy_1]) * order_1;
                    default:
                        return 0;
                }
            });
            this.props.setItems(list);
        }
        if (prevProps.items !== list || this.props.contentWidth === 0) {
            var contentWidth_1 = 0;
            var columns_1 = list.reduce(function (p, item) {
                headers.forEach(function (c) {
                    var dataKey = '__' + c.replace(/-/g, '');
                    var text = getValue(c, item);
                    var length = (0, text_1.calculateStringLength)(text);
                    if (!p[dataKey] || p[dataKey] < length) {
                        p[dataKey] = length;
                    }
                });
                return p;
            }, {});
            headers.forEach(function (x) {
                var dataKey = '__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)(x.toString()).toString();
                var length = (0, text_1.calculateStringLength)(text) + 42;
                if (!columns_1[dataKey] || columns_1[dataKey] < length) {
                    columns_1[dataKey] = length;
                }
            });
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x];
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('UserProjectListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'UserProjectListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 40;
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    }
}), (0, recompose_1.onlyUpdateForKeys)([
    'contentWidth',
    'items',
    'orderByOptions',
    'filterOptions',
    'searchByOptions',
    'projects'
]));
var createRowData = memoize(function (items, toggleSelect, selectedProjects) { return ({
    items: items,
    toggleSelect: toggleSelect,
    selectedProjects: selectedProjects
}); });
exports.UserProjectsList = enhance(function (props) {
    var itemData = createRowData(props.items, props.toggleSelect, props.projects.selectedProjects);
    return (React.createElement("div", { className: 'user-projects-list-container' },
        React.createElement("div", { className: 'user-projects-view-list' },
            props.projects.status === 'FAILED' ? (React.createElement(GenericErrorMessage_1.default, null,
                React.createElement("p", null, (0, translation_1.getLocalization)('admin/userfront/admin/fetchFailed')))) : (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: Math.min((props.items.length + 1) * 50, height), itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, { orderByOptions: props.orderByOptions, sortBy: props.sortBy, setColumnFilter: props.setColumnFilter, filterOptions: props.filterOptions, projects: props.projects, toggleSelect: props.toggleSelect }) }, ListRow));
            })),
            ")")));
});
